﻿import React from 'react';
import ReactModal from 'react-modal';
import { connect } from 'react-redux';
import { ThunkDispatch } from 'redux-thunk';
import { AnyAction } from 'redux';

import { EpiContext } from '../Shared/Scripts/Store/EpiContext/Types';
import { FeilmeldingComponent } from '../Shared/Scripts/Components/FeilmeldingComponent';

import VeilederGenerellDto from './Models/VeilederGenerellDto';
import StegModell from './Models/StegModell';
import StegValgModell from './Models/StegValgModell';
import { VeilederGenerellAppState } from './Store';
import * as Ids from './Ids';
import * as ValgTypes from './Store/Valg/Types';
import { updateValg, updateVisning } from './Store/Valg/Actions';
import { ResultatValg } from './Store/Resultat/Types';
import Steg from './Components/Steg';

interface AppOwnProps {}

type AppProps = AppOwnProps & MapStateToProps & MapDispatchToProps;

ReactModal.setAppElement(document.getElementById(Ids.AppContainerId) as HTMLElement);

export class App extends React.Component<AppProps> {
    constructor(props: AppProps) {
        super(props);
    }

    render(): JSX.Element {
        const { valg, dispatchUpdateValg, epiContext } = this.props;
        const { epiModel } = this.props.epiContext;

        function lagValgModell(nivaa: number, nyttValg: number) {
            //console.log(nivaa, nyttValg);
            if(nivaa === 0) {
                //hvis bruker velger fra første boks, så resetter vi alt. 
                let stegValgt: StegValgModell = { valgtId: nyttValg, nivaa: nivaa };
                let stegValg: StegValgModell[] = [];
                stegValg.push(stegValgt);
                dispatchUpdateValg({ steg: stegValg });
                return;
            }

            let tmpSteg: StegValgModell[] = valg.steg.filter((r) => (r.nivaa < nivaa));
            let endretStegValg: boolean = false;

            for(let q = 0;q<tmpSteg.length;q++) {
                if(tmpSteg[q].nivaa > nivaa) {
                    console.log("hmm... noe er galt. 1");
                    //TODO: denne må tas ut fordi det er barn av nytt valg. 
                }

                if(tmpSteg[q].nivaa == nivaa) {
                    //skriver om eksisterende. vi trenger ikke å legge til ny
                    tmpSteg[q].valgtId = nyttValg;
                    endretStegValg = true;
                }
            }

            if(!endretStegValg) {
                let stegValg: StegValgModell = { valgtId: nyttValg, nivaa: nivaa };
                tmpSteg.push(stegValg);
            }
            
            dispatchUpdateValg({ steg: tmpSteg });
        }

        function hentStegMedBarn(steg: StegModell, counter: number, nivaa: number): any[] | null {
            nivaa++;
            let elements: any = [];
            if(steg.barn !== undefined && steg.barn !== null && steg.barn.length > 0) { // FIX SUGGESTION: Change the meaning of the code to require to be not null, nor undefined before length check
                
                for(let x = 0;x<steg.barn.length;x++) {
                    let key: number = counter + x + 1;
                    elements.push(
                            //TODO
                            valg.steg !== undefined && valg.steg.find((w) => (w.valgtId === steg.barn[x].sideId))?.valgtId === steg.barn[x].sideId && (
                                <Steg 
                                    key={key}
                                    sporsmalId={'generell-steg-'+counter+x}
                                    steg = {steg.barn[x]}
                                    onChange = {(nyttValg: number): void => {
                                        lagValgModell(nivaa, nyttValg);
                                    }}
                                    valgtSteg = {valg.steg}
                                    isCollapsable = {true}
                                />
                            )
                        ); 
                        //rekursivt
                        elements.push(hentStegMedBarn(steg.barn[x], counter + x + 1, nivaa));
                }
            }
            return elements;
        }

        function hentSteg(): any[] | null {

            if(epiModel?.steg === null || epiModel?.steg === undefined || epiModel.steg.length <= 0)
                return null;
            
            let elements: any = [];
            for(let i = 0;i<epiModel.steg.length;i++) {
                
                elements.push(<Steg 
                        key={i}
                        sporsmalId={'generell-steg-'+i}
                        steg = {epiModel.steg[i]}
                        onChange = {(nyttValg: number): void => {
                            lagValgModell(0, nyttValg);
                        }}
                        valgtSteg = {valg.steg}
                        isCollapsable = {false}
                    />); 
                
                elements.push(hentStegMedBarn(epiModel.steg[i], i, 0));
            }

            return elements;
        }

        if (epiContext.epiModelFeilet) {
            return <FeilmeldingComponent />;
        }

        if (epiModel != null) {
            return (
                <div className="c-veileder">
                    {hentSteg()}
                </div>
            );
        } else {
            return <div>Laster...</div>;
        }
    }
}

interface MapStateToProps {
    valg: ValgTypes.ValgState;
    epiContext: EpiContext<VeilederGenerellDto>;
    resultat: ResultatValg;
}

interface MapDispatchToProps {
    dispatchUpdateValg: (newValg: Partial<ValgTypes.ValgState>) => void;
}

const mapDispatchToProps = (dispatch: ThunkDispatch<VeilederGenerellAppState, {}, AnyAction>): MapDispatchToProps => ({
    dispatchUpdateValg: (newValg: Partial<ValgTypes.ValgState>): void => {
        dispatch(updateValg(newValg));
        dispatch(updateVisning());
    },
});

const mapStateToProps = (state: VeilederGenerellAppState): MapStateToProps => ({
    valg: state.valg,
    epiContext: state.epiContext,
    resultat: state.resultat
});

export default connect(mapStateToProps, mapDispatchToProps)(App);
